<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      fixed
      app
      right
      dark
      v-if="$vuetify.breakpoint.smAndDown"
    >
      <v-list style="margin-top:64px;">
        <v-list-tile
          @click="toMission()" >
          <v-list-tile-action>
            <v-icon>mdi-rocket</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>MISSION</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          @click="toScience()" >
          <v-list-tile-action>
            <v-icon>mdi-star</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>SCIENCE</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          @click="toTech()" >
          <v-list-tile-action>
            <v-icon>mdi-hexagon-multiple</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>TECH</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          @click="toData()" >
          <v-list-tile-action>
            <v-icon>mdi-database</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>DATA</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          to="/team" >
          <v-list-tile-action>
            <v-icon>mdi-account-group</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>TEAM</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          to="/gallery" >
          <v-list-tile-action>
            <v-icon>mdi-image-filter</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>GALLERY</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          to="/news" >
          <v-list-tile-action>
            <v-icon>mdi-calendar</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>NEWS</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          to="/contact" >
          <v-list-tile-action>
            <v-icon>mdi-email-outline</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>CONTACT</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar id="topNav" :class="{'hidden':firstPage && $vuetify.breakpoint.mdAndUp}" app dark class="elevation-1" style="z-index:20 !important;">

      <v-toolbar-items>

        <v-container class="hidden-md-and-up pa-0" flex grid-list-sm  >


          <v-layout
            wrap
          >

            <v-flex xs12 md10 xl8 offset-md1 offset-xl2>

              <v-container  class="pa-0" style="max-width: none;">
                <v-layout >
                  <v-flex>

                    <v-btn class="" style="height: 56px; margin-left: -16px;" dark depressed  @click="toLISA()">
                      <i aria-hidden="true" class="v-icon mdi theme--dark" style="font-size: 36px;">
                        <img src="LISA_logo.svg" width="100">
                      </i>
                    </v-btn>


                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
          </v-layout>
        </v-container>

      </v-toolbar-items>

      <template v-slot:extension v-if="$vuetify.breakpoint.mdAndUp">

        <v-toolbar-items  style="position:absolute;right:0;left:0;top:0px;">


          <v-container class="hidden-sm-and-down pa-0" flex grid-list-sm  >



            <v-layout
              wrap
            >

              <v-flex xs12 md10 xl8 offset-md1 offset-xl2>

                <v-container  class="pa-0" style="max-width: none;">
                  <v-layout >
                    <v-flex>

                      <v-btn class="ma-0 big-icon-btn" style="width: 100%; height: 96px;" dark depressed  to="/">
                        <i aria-hidden="true" class="v-icon mdi theme--dark" style="font-size: 36px;">
                          <v-img style="    top: -44px;     width: 52px;
    height: 52px; position: absolute; min-height: 100%;"
                                 :src="require('@/assets/lisa.svg')"
                                 aspect-ratio="1"
                                 alt="LISA"
                                 height="100%"
                          ></v-img>
                        </i>

                        <span style="height:48px; line-height: 48px;" class="mb-2">LISA</span></v-btn>

                    </v-flex>
                    <v-flex>

                      <v-btn class="ma-0 big-icon-btn" style="width: 100%; height: 96px;" dark depressed  to="/#mission">
                        <v-icon large  dark>mdi-rocket</v-icon>
                        <span style="height:48px; line-height: 48px;" class="mb-2">Mission</span></v-btn>

                    </v-flex>
                    <v-flex>

                      <v-btn class="ma-0 big-icon-btn" style="width: 100%; height: 96px;" dark depressed  to="/#science">
                        <v-icon large  dark>mdi-star</v-icon>
                        <span style="height:48px; line-height: 48px;" class="mb-2">Science</span></v-btn>

                    </v-flex>
                    <v-flex>
                      <v-btn class="ma-0 big-icon-btn" style="width: 100%; height: 96px;" dark depressed  to="/#tech">
                        <v-icon large  dark>mdi-hexagon-multiple</v-icon>
                        <span style="height:48px; line-height: 48px;" class="mb-2">Tech</span></v-btn>
                    </v-flex>
                    <v-flex>
                      <v-btn class="ma-0 big-icon-btn" style="width: 100%; height: 96px;" dark depressed  to="/#data">
                        <v-icon large  dark>mdi-database</v-icon>
                        <span style="height:48px; line-height: 48px;" class="mb-2">Data</span></v-btn>
                    </v-flex>
                    <v-flex>
                      <v-btn class="ma-0 big-icon-btn" style="width: 100%; height: 96px;" dark depressed  to="/team">
                        <v-icon large  dark>mdi-account-group</v-icon>
                        <span style="height:48px; line-height: 48px;" class="mb-2">Team</span></v-btn>
                    </v-flex>
                    <v-flex >

                      <v-btn class="ma-0 big-icon-btn" style="width: 100%; height: 96px;" dark depressed  to="/gallery">
                        <v-icon large  dark>mdi-image-filter</v-icon>
                        <span style="height:48px; line-height: 48px;" class="mb-2">Gallery</span></v-btn>

                    </v-flex>

                    <v-flex >
                      <v-btn class="ma-0 big-icon-btn" style="width: 100%; height: 96px;" dark depressed  to="/news">
                        <v-icon large  dark>mdi-calendar</v-icon>
                        <span style="height:48px; line-height: 48px;" class="mb-2">News</span></v-btn>
                    </v-flex>
                    <v-flex >

                      <v-btn class="ma-0 big-icon-btn" style="width: 100%; height: 96px;" dark depressed to="/contact">
                        <v-icon large  dark>mdi-email-outline</v-icon>
                        <span style="height:48px; line-height: 48px;" class="mb-2">Contact</span></v-btn>

                    </v-flex>

                  </v-layout>
                </v-container>

              </v-flex>

            </v-layout>

          </v-container>



        </v-toolbar-items>
      </template>

      <v-spacer v-if="$vuetify.breakpoint.smAndDown"></v-spacer>
      <v-btn @click.stop="drawer = !drawer" icon style="z-index: 100;" v-if="$vuetify.breakpoint.smAndDown">
        <v-icon>mdi-menu</v-icon>
      </v-btn>

    </v-toolbar>

    <v-content style="margin-top:-32px;">
      <router-view/>
      <v-footer style="margin-top:96px;"
                dark
                padless
      >
        <v-card
          style="width: 100%;"
          flat
          tile
          class="grey darken-3 white--text text-xs-center"
        >
          <v-card-text>
            <v-btn
              v-for="icon in icons"
              :key="icon"
              class="mx-4 white--text"
              icon
            >
              <v-icon size="24px">{{ icon }}</v-icon>
            </v-btn>
          </v-card-text>

          <v-card-text class="white--text pt-0 font-weight-light caption">
            This website uses cookies to make the use of the website safer and more effective. By continuing to navigate, you give your consent to this use. More information can be found in our privacy policy.<br/>
            Legal — Privacy Policy
          </v-card-text>

          <v-card-text class="white--text grey darken-4 elevation-2 caption">
            {{ new Date().getFullYear() }} — <strong>LISA Consortium</strong> — info@lisamission.org
          </v-card-text>
        </v-card>
      </v-footer>
    </v-content>

    <v-dialog v-model="searchdialog" fullscreen hide-overlay transition="dialog-top-transition" :content-class="`${$vuetify.breakpoint.xs ? 'fullscreen-top-xs' : ''} ${$vuetify.breakpoint.sm ? 'fullscreen-top-sm' : ''} ${$vuetify.breakpoint.md ? 'fullscreen-top-md' : ''} ${$vuetify.breakpoint.lg ? 'fullscreen-top-lg' : ''} ${$vuetify.breakpoint.xl ? 'fullscreen-top-xl' : ''}`">

      <v-card color="grey darken-3">
        <v-container flex>
          <v-layout
            style="height: 100%;"
            text-xs-left
            wrap
          >

            <v-flex xs12 md10 xl8 offset-md1 offset-xl2 >
              <v-card dark color="transparent" class="elevation-0">

                <v-toolbar dark color="transparent" class="elevation-0">

                  <v-toolbar-title class="display-2 font-weight-thin" style="margin-left: -8px;">Search</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn depressed  color="grey darken-3" @click="searchdialog = false" style="margin-right: -24px;">
                    close
                    <v-icon right dark>mdi-close</v-icon>
                  </v-btn>

                </v-toolbar>
                <v-card-text style="border-radius: 3px; border: 1px solid lightgray;">
                  test
                </v-card-text>
              </v-card>

            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="settingsdialog" fullscreen hide-overlay transition="dialog-top-transition" :content-class="`${$vuetify.breakpoint.xs ? 'fullscreen-top-xs' : ''} ${$vuetify.breakpoint.sm ? 'fullscreen-top-sm' : ''} ${$vuetify.breakpoint.md ? 'fullscreen-top-md' : ''} ${$vuetify.breakpoint.lg ? 'fullscreen-top-lg' : ''} ${$vuetify.breakpoint.xl ? 'fullscreen-top-xl' : ''}`">

      <v-card color="grey darken-3">
        <v-container flex>
          <v-layout
            style="height: 100%;"
            text-xs-left
            wrap
          >

            <v-flex xs12 md10 xl8 offset-md1 offset-xl2 >
              <v-card dark color="transparent" class="elevation-0">

                <v-toolbar dark color="transparent" class="elevation-0 ">

                  <v-toolbar-title class="display-1 font-weight-thin" style="margin-left: -8px;">Settings</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn depressed  color="grey darken-3" @click="closeSettings" style="margin-right: -24px;">
                    close
                    <v-icon right dark>mdi-close</v-icon>
                  </v-btn>

                </v-toolbar>

                <v-select
                  color="grey darken-3"
                  v-model="boxstyle"
                  :items="boxstyles"
                  item-text="name"
                  item-value="value"
                  label="Card Style"
                  outline
                ></v-select>

                <v-select v-if="boxstyle !== 'tabExpand' && false"
                          color="grey darken-3"
                          v-model="landingstyle"
                          :items="landingstyles"
                          item-text="name"
                          item-value="value"
                          label="New page style"
                          outline
                ></v-select>

              </v-card>

            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog  v-model="detailsdealog" fullscreen hide-overlay transition="dialog-bottom-transition" :content-class="`${$vuetify.breakpoint.xs ? 'fullscreen-top-xs' : ''} ${$vuetify.breakpoint.sm ? 'fullscreen-top-sm' : ''} ${$vuetify.breakpoint.md ? 'fullscreen-top-md' : ''} ${$vuetify.breakpoint.lg ? 'fullscreen-top-lg' : ''} ${$vuetify.breakpoint.xl ? 'fullscreen-top-xl' : ''}`">

      <v-card color="grey lighten-1" class="elevation-0">
        <v-container flex style="border-top: 3px solid rgba(255,0,0,.9);">
          <v-layout
            style="height: 100%;"
            text-xs-left
            wrap
          >

            <v-flex xs12 md10 xl8 offset-md1 offset-xl2 >
              <v-card color="transparent" class="elevation-0">
                <v-toolbar color="transparent" class="elevation-0">

                  <v-btn round depressed @click="closeDetails" color="grey ">
                    <v-icon left dark>mdi-arrow-left</v-icon>
                    back
                  </v-btn>

                  <v-spacer></v-spacer>

                  <v-btn round depressed @click="closeDetails" color="grey">
                    share
                    <v-icon right dark>mdi-share</v-icon>
                  </v-btn>

                </v-toolbar>
                <div style="background-color: white;">
                  <v-layout
                    text-xs-left
                    wrap
                  >

                    <v-flex  xs12>
                      <v-card-text class="text-xs-justify" >
                        <div><h3 class="headline mb-3">The first GW observatory in space</h3></div>
                        <div class="subheading">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</div>
                      </v-card-text>
                    </v-flex>
                  </v-layout>

                  <FullPage></FullPage>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>

  </v-app>
</template>

<script>

  import { mapGetters, mapActions } from 'vuex'
  import FullPage from './components/FullPage'

  export default {
    components: {
      FullPage
    },
    name: 'App',
    data () {
      return {
        drawer: null,
        icons: [
          'mdi-facebook',
          'mdi-twitter',
          'mdi-instagram',
          'mdi-youtube'
        ],
        firstPage: false,
        settingsdialog: false,
        searchdialog: false,
        detailsdealog: false,
        boxstyle: 'tabExpand',
        boxstyles: [
          { name: 'Tab (same page)', value: 'tabExpand' },
          { name: 'Tab (new page)', value: 'tabHorizontal' },
          { name: 'Expansion (new page)', value: 'tabVertical' }
        ],
        landingstyle: 'full',
        landingstyles: [
          { name: 'Full page', value: 'full' },
          { name: 'Dialog page', value: 'dialog' }
        ]
      }
    },


    watch: {
      '$route': function () {
        this.openCloseSettings()
      },
      'boxstyle': { // watch if calendars object is changing
        handler (val) {
          console.log(val)
          this.updateTabVersion(val)
        },
        deep: true // You need to set deep to true when watching an array or object so that Vue knows that it should watch the nested data for changes.
      }
    },

    computed: {
      ...mapGetters({
        tabVersion: 'version/tabVersion'
      })
    },
    mounted () {
      this.openCloseSettings()
    },
    methods: {
      toLISA () {
        if (this.firstPage) {
          this.$vuetify.goTo('#lisa',{offset:-22})
        } else {
          this.$router.push('/')
        }
      },
      toMission () {
        if (this.firstPage) {
          this.$vuetify.goTo('#mission',{offset:-34})
        } else {
          this.$router.push('/#mission')
        }
      },
      toScience () {
        if (this.firstPage) {
          this.$vuetify.goTo('#science',{offset:-24})
        } else {
          this.$router.push('/#science')
        }
      },
      toTech () {
        if (this.firstPage) {
          this.$vuetify.goTo('#tech',{offset:-24})
        } else {
          this.$router.push('/#tech')
        }
      },
      toData () {
        if (this.firstPage) {
          this.$vuetify.goTo('#data',{offset:-24})
        } else {
          this.$router.push('/#data')
        }
      },
      ...mapActions({
        updateTabVersion: 'version/updateTabVersion'
      }),
      openCloseSettings () {
        if (this.$router.currentRoute.path === '/') {
          this.firstPage = true
        } else {
          this.firstPage = false
        }

        if (this.$router.currentRoute.hash === ('#settings')) {
          this.settingsdialog = true
        } else if (this.$router.currentRoute.hash === ('#details')) {
          this.detailsdealog = true
        } else {
          this.settingsdialog = false
          this.detailsdealog = false
        }
      },
      closeSettings () {
        this.$router.push(this.$router.currentRoute.path)
      },
      closeDetails () {
        this.$router.push(this.$router.currentRoute.path)
      }
    }
  }

</script>

<style>

  .big-icon-btn {
    height: 88px;
    padding-top: 64px;
  }
  .big-icon-btn .v-icon {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    margin: 0;
    font-size: 36px !important;
  }
  .big-icon-btn .v-icon:before {
    top: -36px;
    position: absolute;
  }

  .v-btn {
    min-width: 50px;
    background: transparent !important;
    border-radius: 0;
  }

  .dialog-top-transition-enter,
  .dialog-top-transition-leave-to {
    transform: translateY(-100%)
  }

  .fullscreen-top-xs
  {    top: 56px !important; }

  .fullscreen-top-sm
  {    top: 48px !important; }

  .fullscreen-top-md
  {    top: 64px !important; }

  .fullscreen-top-lg
  {    top: 64px !important; }

  .fullscreen-top-xl
  {    top: 64px !important; }

  .topzero
  {    top: 0 !important; }

  .v-dialog__content {
    z-index: 10 !important;
  }

  .v-btn--icon {
    min-width: 36px;
  }

  .application--wrap > nav.v-toolbar.elevation-0 {

  }

  .hidden {
    display: none !important;
  }

  #topNav  .v-toolbar__extension {
    height: 32px !important;
  }

</style>
